import { Project } from '@brg/api/dist/api-core/types';
import { FlexBox, useIsMobile } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RectangularButtonFilled } from 'shared/components/buttons';
import { ExploreButtonFilled } from 'shared/pages/explore/styles';
import styled from 'styled-components';
import { AppTester } from 'supporting';

const ContextNameWrapper = styled(FlexBox)`
  width: 100%;
  margin-bottom: 10px;
  height: 47px;
  padding: 13.5px 0 13.5px 0;  
  border-bottom: 1px solid #545453;
`;

const Name = styled.div`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #545453;
`;

export const ProjectContextName: FC<{ }> = ({}) => {
    const isMobile = useIsMobile();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const { t } = useTranslation();


    if (true) {
      return null
    }
    if (!isAgeytomesh) {
      return null;
    }

    return (
        <ContextNameWrapper>
            <Name>agey tomesh</Name>
        </ContextNameWrapper>
    )
}import { Project } from '@brg/api/dist/api-core/types';
import { FlexBox, useIsMobile } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RectangularButtonFilled } from 'shared/components/buttons';
import { ExploreButtonFilled } from 'shared/pages/explore/styles';
import styled from 'styled-components';
import { AppTester } from 'supporting';

const ContextNameWrapper = styled(FlexBox)`
  width: 100%;
  margin-bottom: 10px;
  height: 47px;
  padding: 13.5px 0 13.5px 0;  
  border-bottom: 1px solid #545453;
`;

const Name = styled.div`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #545453;
`;

export const ProjectContextName: FC<{ }> = ({}) => {
    const isMobile = useIsMobile();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const { t } = useTranslation();


    if (true) {
      return null
    }
    if (!isAgeytomesh) {
      return null;
    }

    return (
        <ContextNameWrapper>
            <Name>agey tomesh</Name>
        </ContextNameWrapper>
    )
}